<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>This manuscript would have never reached publication if it wasn’t for the encouragement and guidance of Dr. Zalman Amit, Diane Wheeler and Doug Cooke. Acknowledging them is easy, but thanking them would require another lifetime.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?dc7c01d4